import React from 'react'
import { Badge } from 'reactstrap'

export const SyncResult = ({ result }) => {
  if (result === 'Success') {
    return (
      <Badge style={{ fontSize: '14px', verticalAlign: 'middle' }} color="success">
        Success
      </Badge>
    )
  } else if (result === 'Error') {
    return (
      <Badge style={{ fontSize: '14px', verticalAlign: 'middle' }} color="error">
        Error
      </Badge>
    )
  } else {
    return <div>{result}</div>
  }
}

export default SyncResult
